import { Validator } from 'prop-types';

/** Generates validators for non-nullable, but optional types.
 */
function generateOptionalValidationFunction<T>(expectedType: string): Validator<T> {
  return function (props, propName, componentName, location, propFullName) {
    const { [propName]: data } = props;

    if (data === null) {
      return new Error(`Null ${propName} is not allowed`);
    }

    if (data !== undefined && typeof data !== expectedType) {
      return new Error(
        'Invalid ' +
          location +
          ' `' +
          propFullName +
          '` of type ' +
          ('`' + typeof data + '` supplied to `' + componentName + '`, expected ') +
          ('`' + expectedType + '`.')
      );
    }

    return null;
  };
}

export const optionalBoolValidator = generateOptionalValidationFunction<boolean | undefined>('boolean');
export const optionalDateValidator = generateOptionalValidationFunction<Date | undefined>('Date');
export const optionalNumberValidator = generateOptionalValidationFunction<number | undefined>('number');
export const optionalStringValidator = generateOptionalValidationFunction<string | undefined>('string');
